import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { ChevronDown, ChevronUp } from 'lucide-react';

interface FAQItemProps {
  question: string;
  answer: string;
}

export const FAQItem: React.FC<FAQItemProps> = ({ question, answer }) => {
  const [isOpen, setIsOpen] = useState(false);
  
  return (
    <div className="border-b border-gray-200 py-4">
      <button
        className="flex justify-between items-center w-full text-left"
        onClick={() => setIsOpen(!isOpen)}
      >
        <h3 className="text-lg font-medium text-gray-900">{question}</h3>
        <span className="ml-6 flex-shrink-0">
          {isOpen ? (
            <ChevronUp className="h-5 w-5 text-indigo-500" />
          ) : (
            <ChevronDown className="h-5 w-5 text-gray-500" />
          )}
        </span>
      </button>
      
      {isOpen && (
        <div className="mt-3 pr-12">
          <p className="text-base text-gray-600">{answer}</p>
        </div>
      )}
    </div>
  );
};

export const FAQ: React.FC = () => {
  const { t } = useTranslation();
  
  const faqs = [
    {
      question: t('faq.items.languages.question'),
      answer: t('faq.items.languages.answer')
    },
    {
      question: t('faq.items.accuracy.question'),
      answer: t('faq.items.accuracy.answer')
    },
    {
      question: t('faq.items.simultaneous.question'),
      answer: t('faq.items.simultaneous.answer')
    },
    {
      question: t('faq.items.delay.question'),
      answer: t('faq.items.delay.answer')
    },
    {
      question: t('faq.items.data.question'),
      answer: t('faq.items.data.answer')
    },
    {
      question: t('faq.items.enterprise.question'),
      answer: t('faq.items.enterprise.answer')
    },
  ];

  return (
    <section id="faq" className="py-16 md:py-24 bg-gray-50">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center max-w-3xl mx-auto mb-16">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
            {t('faq.title')}
          </h2>
          <p className="text-xl text-gray-600">
            {t('faq.contactPrefix')} <a href="mailto:contact@thesai.ai" className="text-indigo-600 hover:text-indigo-700">contact@thesai.ai</a>
          </p>
        </div>
        
        <div className="max-w-3xl mx-auto">
          <div className="bg-white rounded-xl shadow overflow-hidden">
            <div className="p-6 md:p-8">
              {faqs.map((faq, index) => (
                <FAQItem
                  key={index}
                  question={faq.question}
                  answer={faq.answer}
                />
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
